import { BellAlertIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { Show } from 'components';
import config from 'config';
import { usePendingPointRedemptionUsages } from 'hooks/data/use-point-redemptions';
import { Link } from 'react-location';

type Props = {
    isCollapsed: boolean;
}

const RedemptionsNotifications = ({ isCollapsed }: Props) => {
    const { redemptions } =
        usePendingPointRedemptionUsages({
            brokerId: config.brokerId,
        });

    const getTotalThreadNotifications = redemptions.length;

    return (
        <Show if={getTotalThreadNotifications > 0}>
            <Link
                to={"/points-redemptions"}
                className={clsx(
                    "group flex items-center w-full px-2 py-2 text-sm rounded-md text-gray-300 hover:bg-card-800 hover:text-white relative", // Added w-full for consistent layout
                    isCollapsed && "justify-center"
                )}
                title="Redemptions Notifications"
            >
                {/* Icon and Badge Container */}
                <div className="relative flex-shrink-0">
                    <BellAlertIcon
                        className={clsx(
                            "text-gray-200 group-hover:text-gray-50 h-6 w-6"
                            // Margin is handled by the text span container below when expanded
                        )}
                        aria-hidden="true"
                    />
                    {/* Badge for Collapsed State (positioned relative to icon) */}
                    {isCollapsed && getTotalThreadNotifications > 0 && (
                        <span
                            className="absolute -top-1 -right-1 inline-flex items-center justify-center px-1.5 py-0.5 text-xs font-bold leading-none text-red-100 bg-red-600 rounded-full transform translate-x-1/4 -translate-y-1/4"
                            aria-label={`${getTotalThreadNotifications} PlaceIT notifications`}
                        >
                            {/* Optionally cap the displayed count */}
                            {getTotalThreadNotifications > 9 ? '9+' : getTotalThreadNotifications}
                        </span>
                    )}
                </div>

                {/* Text and Badge for Expanded State */}
                {!isCollapsed && (
                    <span className="flex-1 flex justify-between items-center ml-3"> {/* Added ml-3 for spacing from icon */}
                        <span>Redemptions</span>
                        {/* Badge for Expanded State (aligned to the right) */}
                        {getTotalThreadNotifications > 0 && (
                            <span
                                className="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 bg-red-600 rounded-full"
                                aria-label={`${getTotalThreadNotifications} Redemptions notifications`}
                            >
                                {getTotalThreadNotifications}
                            </span>
                        )}
                    </span>
                )}

                {/* Tooltip for Collapsed State */}
                {isCollapsed && (
                    <span className="absolute left-full ml-2 w-auto min-w-max rounded bg-black text-xs text-white p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                        Redemptions Notifications
                    </span>
                )}
            </Link>
        </Show>
    )
}

export default RedemptionsNotifications;